// Centralized site config / data for SIGNA CLEAN
import {
  Wind,
  Sparkles,
  Lightbulb,
  CircleDot,
  ShieldCheck,
  Zap,
  Wrench,
  MapPin,
  Award,
  Feather,
} from "lucide-react";

export const BRAND = {
  name: "SIGNA CLEAN",
  tagline: "Sécuriser, Valoriser, Innover",
  phone: "0696 68 77 66",
  phoneHref: "tel:+596696687766",
  email: "contact@signaclean.com",
  emailHref: "mailto:contact@signaclean.com",
  zone: "Toute la Martinique",
  address: {
    line1: "Immeuble EQUINOXES, 12 rue des Arts et Métiers",
    line2: "Lotissement Dillon Stade",
    city: "97200 Fort-de-France",
    region: "Martinique",
    full: "Immeuble EQUINOXES, 12 rue des Arts et Métiers, Lotissement Dillon Stade, 97200 Fort-de-France, Martinique",
  },
  hours: "Lun – Ven : 8h – 16h",
  clientPortal: "https://app.signaclean.fr/espace-client",
  teamPortal: "https://app.signaclean.fr/equipe",
  logo:
    "https://customer-assets.emergentagent.com/job_af3e87a7-0083-46c2-98e0-bcedbffc0575/artifacts/sbphxmps_Signa-Clean-Logo-Final-Mod.png",
};

export const HERO = {
  kicker: "Martinique · BTP & Innovation",
  title: "Sécurisez, valorisez et entretenez vos infrastructures.",
  subtitle:
    "Solutions innovantes en nettoyage technique, équipements photoluminescents et signalisation solaire en Martinique.",
  cta: "Demander un devis gratuit",
  background:
    "https://images.pexels.com/photos/18290521/pexels-photo-18290521.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
};

export const WHY_US = [
  {
    icon: Wrench,
    title: "Expertise terrain",
    desc: "Interventions professionnelles, équipe formée aux techniques BTP et sécurité.",
  },
  {
    icon: Sparkles,
    title: "Solutions innovantes",
    desc: "Des équipements performants et des procédés durables, conçus pour garantir efficacité, sécurité et respect des infrastructures.",
  },
  {
    icon: Zap,
    title: "Matériel spécialisé",
    desc: "Perches télescopiques, aspirations haute portée, équipements techniques.",
  },
  {
    icon: MapPin,
    title: "Intervention rapide",
    desc: "Réactivité sur toute la Martinique : nord, centre, sud Atlantique et Caraïbe.",
  },
  {
    icon: ShieldCheck,
    title: "Sécurité & performance",
    desc: "Approche orientée résultat avec respect strict des normes et supports.",
  },
];

export const SERVICES = [
  {
    id: "gouttieres",
    icon: Wind,
    title: "Nettoyage de gouttières",
    short: "Aspiration haute portée jusqu'à 12 m sans nacelle.",
    bullets: [
      "Élimination des feuilles, boues, racines",
      "Prévention des infiltrations et dégâts",
      "Idéal pour bâtiments, résidences et écoles",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/rsqacls6_C2363195-0B69-4A5B-9686-90E67343C2EA.png",
    tag: "Aspiration · 12 m",
  },
  {
    id: "facades",
    icon: Sparkles,
    title: "Nettoyage de façades, toitures & lessivage",
    short: "Nettoyage professionnel à la perche télescopique avec produits adaptés. Lessivage de sols et surfaces.",
    bullets: [
      "Bardages métalliques",
      "Façades d'immeubles",
      "Toitures en tuiles",
      "Lessivage sols, murs et surfaces",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/lvnw8542_229692DC-6C6B-49E8-9D08-F797665A44A2.png",
    tag: "Sécurité",
  },
  {
    id: "photoluminescent",
    icon: Lightbulb,
    title: "Équipements photoluminescents",
    short: "Dispositifs de sécurité visibles dans l'obscurité, sans électricité.",
    bullets: [
      "Nez de marches",
      "Bandes murales",
      "Signalisation d'évacuation",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/c5hu83hl_IMG_9259.jpeg",
    tag: "0 électricité",
  },
  {
    id: "plots-solaires",
    icon: CircleDot,
    title: "Plots solaires LED",
    short: "Sécurisation des espaces publics avec une visibilité renforcée la nuit.",
    bullets: [
      "Passages piétons",
      "Voiries",
      "Zones à faible visibilité",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/7gn7dlfs_0C398A45-FDFE-4683-802D-AEF0C51506D0.png",
    tag: "Solaire · LED",
  },
  {
    id: "depoussierage",
    icon: Feather,
    title: "Dépoussiérage en hauteur",
    short: "Élimination professionnelle des poussières sur supports difficiles d'accès, sans nacelle.",
    bullets: [
      "Charpentes métalliques & poutres",
      "Gaines de ventilation et conduits",
      "Luminaires industriels & installations techniques",
      "Plafonds hauts et structures suspendues",
    ],
    image:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/4u0hfnic_IMG_2377.jpeg",
    imagePosition: "center 30%",
    tag: "Perche · Hauteur",
  },
];

export const TRUST_POINTS = [
  { icon: Award, label: "Matériel professionnel haut de gamme" },
  { icon: ShieldCheck, label: "Respect des normes et des supports" },
  { icon: Wrench, label: "Interventions sécurisées" },
  { icon: Sparkles, label: "Accompagnement personnalisé" },
];

export const CLIENT_TYPES = [
  "Particuliers",
  "Entreprises",
  "Collectivités",
  "Bailleurs sociaux",
];

// Liste utilisée pour les formulaires de devis et le WhatsApp
// (inclut un service supplémentaire "Nettoyage de sols / Lessivage")
export const QUOTE_SERVICES = [
  "Nettoyage de gouttières",
  "Nettoyage de façades / toitures",
  "Nettoyage / Lessivage de sols",
  "Dépoussiérage en hauteur",
  "Équipements photoluminescents",
  "Plots solaires LED",
  "Autre demande",
];

export const GALLERY = [
  {
    id: 1,
    title: "Nettoyage gouttières · Villa",
    before:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/cdrgsulk_IMG_2500.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/lft0ssuw_IMG_2508.jpeg",
    beforePosition: "center",
    afterPosition: "center top",
  },
  {
    id: 2,
    title: "Lessivage escalier · RSMA",
    before:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/g1h4dokl_ADC6F9CE-7053-478E-AF08-4E60345E1718.png",
    after:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/gizd2suy_IMG_2769.jpeg",
  },
  {
    id: 3,
    title: "Sécurisation escalier · Photoluminescent (jour / nuit)",
    before:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/8p4m2m54_IMG_9242.jpeg",
    after:
      "https://customer-assets.emergentagent.com/job_nettoyage-martinique/artifacts/re3ig8vw_D5DC790C-7773-4E42-9AFF-E8BDF7473DA0.PNG",
    beforePosition: "center",
    afterPosition: "center",
  },
];

export const MARTINIQUE_BG =
  "https://images.pexels.com/photos/20342203/pexels-photo-20342203.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600";
